import _isNil from 'lodash/isNil'
import _isNumber from 'lodash/isNumber'

export function formatCurrency({
  amount = null,
  locale = 'en-US',
  currency = 'USD',
  minimumFractionDigits = 0,
} = {}) {
  if (_isNil(amount) || amount === 0) return '$0'
  if (!_isNumber(amount) && amount?.includes('$')) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(parseInt(amount.replaceAll('$', '').replaceAll(',', ''), 10))
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
  }).format(parseInt(amount, 10))
}

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export function getLatestValue(array: any[]) {
  if (!array || array.length === 0) return null
  const mostRecentDate = new Date(
    Math.max(...array.map((e) => new Date(e.reportOrderedAt || e.report_ordered_at).getTime()))
  )
  const mostRecentObject = array.find((e) => {
    const d = new Date(e.reportOrderedAt || e.report_ordered_at)
    return d.getTime() == mostRecentDate.getTime()
  })
  return mostRecentObject
}

export function isJSON(str: string) {
  if (typeof str !== 'string') return false
  try {
    const result = JSON.parse(str)
    const type = Object.prototype.toString.call(result)
    return type === '[object Object]' || type === '[object Array]'
  } catch (err) {
    return false
  }
}

/** @deprecated Use lodash.isEqual instead */
export function shallowObjectCompare(initial, current) {
  for (const key in initial) {
    if (!(key in current) || initial[key] !== current[key]) {
      return false
    }
  }
  for (const key in current) {
    if (!(key in initial) || current[key] !== initial[key]) {
      return false
    }
  }
  return true
}

/**
 * Basic English string pluralizer
 * @param noun
 * @param count
 * @returns A pluralized string that ends with 's' if count is greater than 1
 */
export const maybePluralize = (noun: string, count: number) => {
  if (noun.endsWith('s')) {
    return noun
  }
  if (noun.endsWith('y')) {
    return count !== 1 ? `${noun.slice(0, -1)}ies` : `${noun}`
  }
  return count !== 1 ? `${noun}s` : `${noun}`
}
